'use strict';

var _ = require('lodash');
var ispmImplDataHandler = {};
//===================================================================================================

ispmImplDataHandler.displayRootElement = function (show) {

  return showHideElement("section-similar-patients", show);
};
//===================================================================================================

ispmImplDataHandler.getPatientID = function (row, i, GUID) {

  // active patient's ID is not within a context
  if (!row['context']) return row.id;

  var patientId = void 0;
  _.each(row['context'], function (context) {

    if (context['resourceType'] === 'Patient') {
      patientId = context['reference'];
      return false; // has the same effect as using break
    }
  });

  return patientId;
};
//===================================================================================================

ispmImplDataHandler.getActivePatientID = function (row, activePatient) {

  // active patient's ID is not within a context
  return activePatient.id;
};
//===================================================================================================

ispmImplDataHandler.getPatientName = function (row, i) {
  return row.name;
};
//===================================================================================================

ispmImplDataHandler.getPatientTooltipLabel = function (row, i, patientName) {
  return patientName;
};
//===================================================================================================

ispmImplDataHandler.onChangeSampleSizeWarning = function (sampleSizeTooSmall) {

  // when the samples size is too small - hide the charts section
  return showHideElement("div-charts", !sampleSizeTooSmall);
};
//===================================================================================================

function showHideElement(elementId, show) {

  var element = document.getElementById(elementId);

  if (element) {
    element.style.display = show ? 'inline-block' : 'none';
  }

  return element;
}
//===================================================================================================

module.exports = ispmImplDataHandler;